import { success } from 'toastr';
import {
  FETCH_EXPENSES_HEADS_REQUEST,
  FETCH_EXPENSES_HEADS_SUCCESS,
  FETCH_EXPENSES_HEADS_FAILURE,
  SAVE_EXPENSES_HEAD_REQUEST,
  SAVE_EXPENSES_HEAD_SUCCESS,
  SAVE_EXPENSES_HEAD_FAILURE,
  CHANGE_EXPENSES_HEAD_STATUS_REQUEST,
  CHANGE_EXPENSES_HEAD_STATUS_SUCCESS,
  CHANGE_EXPENSES_HEAD_STATUS_FAILURE,
  FETCH_EXPENSES_SUBHEADS_REQUEST,
  FETCH_EXPENSES_SUBHEADS_SUCCESS,
  FETCH_EXPENSES_SUBHEADS_FAILURE,
  SAVE_EXPENSES_SUBHEAD_REQUEST,
  SAVE_EXPENSES_SUBHEAD_SUCCESS,
  SAVE_EXPENSES_SUBHEAD_FAILURE,
  CHANGE_EXPENSES_SUBHEAD_STATUS_REQUEST,
  CHANGE_EXPENSES_SUBHEAD_STATUS_SUCCESS,
  CHANGE_EXPENSES_SUBHEAD_STATUS_FAILURE,
  FETCH_EXPENSES_MAPPED_HEADS_REQUEST,
  FETCH_EXPENSES_MAPPED_HEADS_SUCCESS,
  FETCH_EXPENSES_MAPPED_HEADS_FAILURE,
  CHANGE_MAPPED_HEAD_STATUS_FAILURE,
  SAVE_MAPPED_HEAD_FAILURE,
  FETCH_MAPPED_HEADS_FAILURE,
  CHANGE_MAPPED_HEAD_STATUS_SUCCESS,
  FETCH_MAPPED_HEADS_REQUEST,
  SAVE_MAPPED_HEAD_REQUEST,
  CHANGE_MAPPED_HEAD_STATUS_REQUEST,
  FETCH_MAPPED_HEADS_SUCCESS,
  SAVE_MAPPED_HEAD_SUCCESS,
  FETCH_EXPENSE_ENTRY_REQUEST,
  SAVE_EXPENSE_ENTRY_REQUEST,
  FETCH_EXPENSE_ENTRY_SUCCESS,
  SAVE_EXPENSE_ENTRY_SUCCESS,
  FETCH_EXPENSE_ENTRY_FAILURE,
  SAVE_EXPENSE_ENTRY_FAILURE,
  CHANGE_EXPENSES_ENTRY_STATUS_FAILURE,
  CHANGE_EXPENSES_ENTRY_STATUS_SUCCESS,
  CHANGE_EXPENSES_ENTRY_STATUS_REQUEST,
  FETCH_EXPENSES_ENTRY_MAPPED_HEADS_FAILURE,
  FETCH_EXPENSES_ENTRY_MAPPED_HEADS_SUCCESS,
  FETCH_EXPENSES_ENTRY_MAPPED_HEADS_REQUEST,
  FETCH_EXPENSE_ENTRY_REPORT_REQUEST,
  FETCH_EXPENSE_ENTRY_REPORT_SUCCESS,
  FETCH_EXPENSE_ENTRY_REPORT_FAILURE,
  FETCH_EXPENSES_APPROVAL_LISTS_REQUEST,
  FETCH_EXPENSES_APPROVAL_LISTS_SUCCESS,
  FETCH_EXPENSES_APPROVAL_LISTS_FAILURE,
  SAVE_EXPENSES_APPROVAL_LISTS_REQUEST,
  SAVE_EXPENSES_APPROVAL_LISTS_SUCCESS,
  SAVE_EXPENSES_APPROVAL_LISTS_FAILURE,
  FETCH_EXPENSES_HEADS_GRID_REQUEST,
  FETCH_EXPENSES_HEADS_GRID_SUCCESS,
  FETCH_EXPENSES_HEADS_GRID_FAILURE
} from './actionTypes';

const initialState = {
  loading: false,
  masterheads: [],
  mastersubheads: [],
  mappedheads: [],
  mappedheadslist: [],
  expenseEntryList: [],
  reports: [],
  approvalLists: [],
  mappedGridheads: [],
  error: null,
  success: false,
};

const expensesMasterReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EXPENSES_HEADS_REQUEST:
    case SAVE_EXPENSES_HEAD_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case FETCH_EXPENSES_HEADS_SUCCESS:
      return { ...state, loading: false, masterheads: action.payload, success: false };

    case FETCH_EXPENSES_HEADS_FAILURE:
    case SAVE_EXPENSES_HEAD_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case SAVE_EXPENSES_HEAD_SUCCESS:
      return { ...state, loading: false, success: true };

    case CHANGE_EXPENSES_HEAD_STATUS_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case CHANGE_EXPENSES_HEAD_STATUS_SUCCESS:
      return { ...state, loading: false, success: true };

    case CHANGE_EXPENSES_HEAD_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case FETCH_EXPENSES_SUBHEADS_REQUEST:
      return { ...state, loading: true, success: false };

    case FETCH_EXPENSES_SUBHEADS_SUCCESS:
      return { ...state, loading: false, mastersubheads: action.payload, success: false };

    case FETCH_EXPENSES_SUBHEADS_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case SAVE_EXPENSES_SUBHEAD_REQUEST:
      return { ...state, loading: true, success: false };

    case SAVE_EXPENSES_SUBHEAD_SUCCESS:
      return { ...state, loading: false, success: true };

    case SAVE_EXPENSES_SUBHEAD_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case CHANGE_EXPENSES_SUBHEAD_STATUS_REQUEST:
      return { ...state, loading: true, success: false };

    case CHANGE_EXPENSES_SUBHEAD_STATUS_SUCCESS:
      return { ...state, loading: false, success: true };

    case CHANGE_EXPENSES_SUBHEAD_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case FETCH_EXPENSES_MAPPED_HEADS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      };
    case FETCH_EXPENSES_MAPPED_HEADS_SUCCESS:
      return {
        ...state,
        loading: false,
        mappedheads: action.payload,
        success: false
      };
    case FETCH_EXPENSES_MAPPED_HEADS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false
      };

    case FETCH_MAPPED_HEADS_REQUEST:
    case SAVE_MAPPED_HEAD_REQUEST:
    case CHANGE_MAPPED_HEAD_STATUS_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case FETCH_MAPPED_HEADS_SUCCESS:
      return { ...state, loading: false, mappedheadslist: action.payload };

    case SAVE_MAPPED_HEAD_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case CHANGE_MAPPED_HEAD_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case FETCH_MAPPED_HEADS_FAILURE:
    case SAVE_MAPPED_HEAD_FAILURE:
    case CHANGE_MAPPED_HEAD_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case FETCH_EXPENSE_ENTRY_REQUEST:
    case SAVE_EXPENSE_ENTRY_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case FETCH_EXPENSE_ENTRY_SUCCESS:
      return { ...state, loading: false, expenseEntryList: action.payload, success: false };

    case SAVE_EXPENSE_ENTRY_SUCCESS:
      return { ...state, loading: false, success: true };

    case FETCH_EXPENSE_ENTRY_FAILURE:
    case SAVE_EXPENSE_ENTRY_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case FETCH_EXPENSES_ENTRY_MAPPED_HEADS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      };
    case FETCH_EXPENSES_ENTRY_MAPPED_HEADS_SUCCESS:
      return {
        ...state,
        loading: false,
        mappedheads: action.payload,
        success: false
      };
    case FETCH_EXPENSES_ENTRY_MAPPED_HEADS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false
      };
    case CHANGE_EXPENSES_ENTRY_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      };
    case CHANGE_EXPENSES_ENTRY_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true
      };
    case CHANGE_EXPENSES_ENTRY_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false
      };

    case FETCH_EXPENSE_ENTRY_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      };
    case FETCH_EXPENSE_ENTRY_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        reports: action.payload,
        success: false
      };
    case FETCH_EXPENSE_ENTRY_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false
      };

    case FETCH_EXPENSES_APPROVAL_LISTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      };
    case FETCH_EXPENSES_APPROVAL_LISTS_SUCCESS:
      return {
        ...state,
        loading: false,
        approvalLists: action.payload,
        success: false
      };
    case FETCH_EXPENSES_APPROVAL_LISTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false
      };

    case SAVE_EXPENSES_APPROVAL_LISTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      };
    case FETCH_EXPENSES_APPROVAL_LISTS_SUCCESS:
      return {
        ...state,
        loading: false,
        approvalLists: action.payload,
        success: false
      };
    case SAVE_EXPENSES_APPROVAL_LISTS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true
      };
    case FETCH_EXPENSES_APPROVAL_LISTS_FAILURE:
    case SAVE_EXPENSES_APPROVAL_LISTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false
      };
    case FETCH_EXPENSES_HEADS_GRID_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      };
    case FETCH_EXPENSES_HEADS_GRID_SUCCESS:
      return {
        ...state,
        loading: false,
        mappedGridheads: action.payload,
        success: false
      };
    case FETCH_EXPENSES_HEADS_GRID_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false
      };
    default:
      return state;
  }
};

export default expensesMasterReducer;
